export default __webpack_public_path__ + "static/media/Logout.23127490.svg";